import React from 'react';
import { PRICE, TOTAL_VALUE, SAVINGS, DISCOUNT } from '../data/content';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
type FinalCtaProps = {
  showUrgency?: boolean;
};
export function FinalCta({
  showUrgency = true
}: FinalCtaProps) {
  return <section className="bg-mint-800 py-20 sm:py-28" aria-labelledby="cierre-title" data-id="element-76" data-mp="15ckkcxgpcgd0">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-77" data-mp="1jc3e2l8rnp5s">
        <Reveal data-id="element-78" data-mp="1ee1wy5uwhzwy">
          <h2 id="cierre-title" className="font-display text-3xl leading-tight text-white sm:text-4xl lg:text-[2.75rem]" data-id="element-79" data-mp="1eek1rqvmpmgh">
            Tu próximo pedido puede llegarte esta semana. Que te encuentre con el menú, la lista y la cotización listos.
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-mint-100" data-id="element-80" data-mp="1o5y7ige6bii2">
            Recetas con costo por pieza y menús completos. Todo para tu cocina de casa.
          </p>
        </Reveal>

        {showUrgency ? <Reveal delay={0.06} className="mt-12" data-id="element-81" data-mp="n5m6a278a41v">
            <CountdownTimer tone="dark" label="PROMO HASTA" note={`Ahorras ${SAVINGS} sobre el valor total.`} data-id="element-82" data-mp="n6w6oy1jzobo" />
          </Reveal> : null}

        <Reveal delay={0.08} data-id="element-83" data-mp="s6ilhbx15cml">
          <div className="mt-12 rounded-3xl bg-sand px-8 py-10 sm:px-12" data-id="element-84" data-mp="x3915y4xa67h">
            <p className="text-sm font-semibold uppercase tracking-[0.16em] text-terra-dark" data-id="element-85" data-mp="x64uta9qm8q4">
              Pack completo
            </p>
            <p className="mt-3 text-[15px] text-ink-soft" data-id="element-86" data-mp="1658f2hkn4u67">
              3 tomos + 40 recetas + 6 menús + 5 bonos
            </p>
            <p className="mt-5 text-sm text-ink-muted" data-id="element-87" data-mp="1b1ytl0gsrhpi">
              <span className="line-through" data-id="element-88" data-mp="1ftqg8zwu13ad">{TOTAL_VALUE}</span> · {DISCOUNT} de descuento
            </p>
            <p className="mt-1 font-display text-5xl text-ink" data-id="element-89" data-mp="1ktmjuy1maspe">{PRICE}</p>
            <div className="mt-7" data-id="element-90" data-mp="1psfumipis5lv">
              <CtaButton data-id="element-91" data-mp="1pth8euxx767a">Quiero empezar a vender</CtaButton>
            </div>
            <p className="mt-5 text-xs text-ink-muted" data-id="element-92" data-mp="1ttjedgaoulsd">
              Precio en pesos mexicanos. Pago 100% seguro ·
              Acceso inmediato · Garantía de 7 días.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}